import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useState } from "react";
import axios from "axios";
import baseUrl from "../../../../BaseURL";
import AlertPOP from "../../../../routes/AlertPOP";
import { ContextData } from "../../../../context/Context";
import validator from "validator";
import { Tooltip } from "@mui/material";
import Loader from "../../../../routes/Loader";
import AddIcon from "@mui/icons-material/Add";
import { Getrequest, Postrequest } from "../../../../context/AxiosRequest";
import { toast } from "react-toastify";
import SoundAlert from "../../../../routes/SoundAlert";


export default function SetLoanRegistrationForm() {



  /* , , , , , , ,bank_name,bank_token */
  const [open, setOpen] = React.useState(false);
  const { RefreshUesFF, setRefreshUesFF, GlobalLoader, setGlobalLoader,accesstoken } = React.useContext(ContextData);
  const [OpenLoader, setOpenLoader] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Form start---------->

  const [formData, setFormData] = useState({
    loan_name: "",
    loan_type: "",
    qualification_type: "",
    residential_type: "",
    will_pay: "",
    amount_to_pay: "0.00",
    loan_description: ""
  });

  const handleInputChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const [message, setMessage] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [transition, setTransition] = useState(undefined);
  const [BankList,setBankList] = useState(null)



  React.useEffect(()=>{

  
          Getrequest("/auth/get_gank",accesstoken).then(res=>{
                          
                  setBankList(res)
  
                 }).catch((err) => {
                  toast.warning(err)
                if (err) return console.log(err);
      });     
   
       

  },[])
 



  // Handle the alert transition and function
  const handleClick = () => {
    setTransition(() => "TransitionLeft");
    setOpenAlert(true);
  };

  // Handle the close alert box
  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  // Handle submit
  const handleSubmit = (e) => {
    e.preventDefault();

    // Call Alert Box function
    handleClick("left");

    // Check for empty fields excluding will_pay
    const isEmptyField = Object.entries(formData).some(([key, value]) => key !== "amount_to_pay" && value === "");

    if (isEmptyField) {
      setMessage("Please fill out all fields");
      return;
    }

    if (formData.will_pay === "yes"){
      if (!validator.isNumeric(formData.amount_to_pay)) {
        setMessage("Amount is not a number");
        return;
      }

      if (formData.amount_to_pay === ""){
        setMessage("Amount to pay must not be empty");
        return;
      }

    } else if (formData.will_pay === "no" && formData.amount_to_pay !== "0.00") {
      setMessage("Amount to pay must be 0.00 when will pay is No");
      return;
    }



    setOpenLoader(true);
    // Submit the form (you can implement your submission logic here)

              (async ()=>{

                   Postrequest("/auth/set_loan",formData,accesstoken).then(res=>{

         if (res.status) {
          setMessage(res.statusText);
          setRefreshUesFF(!RefreshUesFF);
          setOpenLoader(false);
          setFormData({
            loan_name: "",
            loan_type: "",
            qualification_type: "",
            residential_type: "",
            will_pay: "",
            amount_to_pay: "0.00",
            loan_description: ""
          });
          setGlobalLoader(!GlobalLoader);
          SoundAlert("success")
        }
                     
                   }).catch((err) => {
        setOpenLoader(false);
        if (err) return console.log(err);
      });
                       
        
              })()
  
      
  };



  // Form end --------->

  return (
    <React.Fragment>
      <Loader OpenLoader={OpenLoader} />
      <Button variant="contained" onClick={handleClickOpen} startIcon={<AddIcon />}>
        Set Loan
      </Button>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="py-10"
        fullWidth
        maxWidth="md"
      >
        <AlertPOP
          Open={openAlert}
          handleClose={handleCloseAlert}
          transition={transition}
          message={message}
        />
        <DialogTitle id="alert-dialog-title">New Loan</DialogTitle>

        <DialogContent>
          <form onSubmit={handleSubmit}>
              <TextField
              select
              label="Bank Name"
              variant="outlined"
              fullWidth
              margin="normal"
              value={formData.loan_name}
              onChange={handleInputChange("loan_name")}
            >

              {
                BankList !== null && BankList.map((bank,index)=> ( <MenuItem key={index} value={bank.bank_name}>{bank.bank_name}</MenuItem>))
              }
             
            
            </TextField>
           
            <TextField
              select
              label="Loan Type"
              variant="outlined"
              fullWidth
              margin="normal"
              value={formData.loan_type}
              onChange={handleInputChange("loan_type")}
            >
              <MenuItem value="local">Local</MenuItem>
              <MenuItem value="foreign">Foreign</MenuItem>
            </TextField>
            <TextField
              select
              label="Qualification Type"
              variant="outlined"
              fullWidth
              margin="normal"
              value={formData.qualification_type}
              onChange={handleInputChange("qualification_type")}
            >
              <MenuItem value="undergraduate">Undergraduate</MenuItem>
              <MenuItem value="postgraduate">Postgraduate</MenuItem>
              <MenuItem value="both">Both</MenuItem>
            </TextField>
            <TextField
              select
              label="Residential Type"
              variant="outlined"
              fullWidth
              margin="normal"
              value={formData.residential_type}
              onChange={handleInputChange("residential_type")}
            >
              <MenuItem value="indigene">Indigene</MenuItem>
              <MenuItem value="resident">Resident</MenuItem>
              <MenuItem value="both">Both</MenuItem>
            </TextField>
      
            <label>Will Pay :</label>
            <RadioGroup
              row
              value={formData.will_pay}
              onChange={handleInputChange("will_pay")}
            >
              <FormControlLabel value="yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="no" control={<Radio />} label="No" />
            </RadioGroup>
            <Tooltip title="Will Pay means is there a payment for this scholarship before applying. If yes, then put the amount. If no, then leave it the way it is.">
              {formData.will_pay === "yes" && (
                <TextField
                  label="Amount to Pay"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  value={formData.amount_to_pay}
                  onChange={handleInputChange("amount_to_pay")}
                />
              )}
            </Tooltip>
            <TextField
              label="Loan Terms and Condition"
              variant="outlined"
              fullWidth
              margin="normal"
              multiline
              rows={4}
              value={formData.loan_description}
              onChange={handleInputChange("loan_description")}
              inputProps={{ maxLength: 9000 }}
            />

            <Button type="submit" variant="contained" color="primary">
              Add
            </Button>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
